<script>
  import Spinner from './Spinner.svelte'
</script>

<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-r from-[rgba(0,0,0,.6)] to-[rgba(0,0,0,.7)] text-[3rem] text-white"
>
  <Spinner />
</div>
